import { render, staticRenderFns } from "./AccidentAllIndividualForm.vue?vue&type=template&id=519b548b&scoped=true"
import script from "./AccidentAllIndividualForm.vue?vue&type=script&lang=js"
export * from "./AccidentAllIndividualForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentAllIndividualForm.vue?vue&type=style&index=0&id=519b548b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b548b",
  null
  
)

export default component.exports